const eventEmitter = new EventTarget();

export const emitEvent = (eventName, detail) => {
  eventEmitter.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const listenEvent = (eventName, callback) => {
  eventEmitter.addEventListener(eventName, callback);
};

export const removeListener = (eventName, callback) => {
  eventEmitter.removeEventListener(eventName, callback);
};
